import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";

import LoadingSpinner from "Components/UI/LoadingSpinner";

import { DatePicker, message, Table, Alert, Spin, Select } from "antd";
const { RangePicker } = DatePicker;
import TableTop from "Components/UI/TableTop";
import { useGetAttendanceListingQuery } from "AppQuries/attendance/attendance-listing";
import { useGetEmployeeMovementQuery } from "AppQuries/employee/employee-movement";
import { all_routes } from "Router/all_routes";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { base_path } from "environment";
import { format } from "date-fns";

const attendanceTypeOptions = [
  {
    label: "New Joined",
    value: "1",
  },
  {
    label: "Exited",
    value: "2",
  },
  {
    label: "Transfer",
    value: "3",
  },
  {
    label: "Visa Expired",
    value: "4",
  },
  {
    label: "PassPort Expired",
    value: "5",
  },
  {
    label: "Contract Expired",
    value: "6",
  },
];

const EmployeeMovements = () => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [empMovementType, setEmpMovementType] = useState(
    searchParams.get("status") ?? 0,
  );

  const {
    data: attendanceData,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: fetchAttendance,
  } = useGetEmployeeMovementQuery({
    status: empMovementType,
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    userId: userData?.userID,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
  });

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "employeePhotoStr",
      width: 100,
      render: (text, record) => (
        <div className="">
          {record?.employeePhotoStr === "" ||
          record?.employeePhotoStr === null ? (
            // <Link to="#" className="">
            <ImagePreview
              src={
                record?.gender === "M"
                  ? base_path + "assets/img/profiles/men.png"
                  : record?.gender === "F"
                    ? base_path + "assets/img/profiles/women.png"
                    : base_path + "assets/img/profiles/men.png"
              }
              alt="Employee Image"
            />
          ) : (
            // <ImageWithBasePath
            //   alt=""
            //   src={
            //     record?.gender === "M"
            //       ? "assets/img/profiles/men.png"
            //       : record?.gender === "F"
            //       ? "assets/img/profiles/women.png"
            //       : "assets/img/profiles/men.png"
            //   }
            //   width={60}
            // />
            // </Link>
            <ImagePreview
              src={record?.imageFilePath || record?.employeePhotoStr}
              alt={record.uniqueId}
            />
          )}
        </div>
      ),
    },
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      // width: 100,
    },
    {
      title: "Fullname",
      dataIndex: "fullName",
      fixed: "left",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      // width: 300,
      render: (text, record) => (
        <Link
          className="me-2 p-2"
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {record.fullName}
        </Link>
      ),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      width: 100,
      render: (text, record) => (
        <>
          {text === "M" && <div>Male</div>}
          {text === "F" && <div>Female</div>}
          {text === "T" && <div>Trans</div>}
        </>
      ),
      sorter: (a, b) => a.gender.length - b.gender.length,
    },
    {
      title: "Department",
      dataIndex: "departmentname",
      width: 100,
      sorter: (a, b) => a.departmentname.length - b.departmentname.length,
    },

    {
      title: "Nationality",
      dataIndex: "nationality",
      width: 100,
      sorter: (a, b) => a.nationality.length - b.nationality.length,
    },

    ...(empMovementType === "1"
      ? [
          {
            title: "Join Date",
            dataIndex: "joinDate",
            key: "attendanceDate",
            render: (text, record) => (
              <>{format(new Date(text), "dd-MM-yyyy")}</>
            ),
          },
        ]
      : []),

    {
      title: "Status",
      dataIndex: "isActive",
      width: 100,
      render: (text, record) => (
        <>
          {record.isActive === true && (
            <span className="badges badge-linesuccess">Active</span>
          )}
          {record.isActive === false && (
            <span className="badges badge-linedanger">In Active</span>
          )}
        </>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    attendanceData,
    searchColumns,
  );

  useEffect(() => {
    if (!empMovementType) return;

    const params = new URLSearchParams(searchParams);

    params.set("status", empMovementType);

    setSearchParams(params);
    fetchAttendance();
  }, [empMovementType]);

  if (isLoading || isFetching) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Attendance Summary</h4>
                <h6>Manage your employees attendance</h6>
              </div>
            </div>
            <div className="page-btn">
              <Select
                options={attendanceTypeOptions}
                placeholder="Select Attendance Type"
                className={`select`}
                value={attendanceTypeOptions.find(
                  (option) => option.value === empMovementType,
                )}
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setEmpMovementType(selectedOption);
                }}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "200px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>

            {/* <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onAttendanceExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div> */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-list-card mt-2">
                <TableTop
                  onSearch={setSearchValue}
                  searchValue={searchValue}
                  toggleFilterVisibility={toggleFilterVisibility}
                  showToggle={false}
                  isFilterVisible={isFilterVisible}
                />
                <div className="table-responsive">
                  <Spin size="large" spinning={isLoading || isFetching}>
                    <Table
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      pagination={true}
                      rowKey="employeeCode"
                    />
                    {isError && <Alert message={error} type="error" />}
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeMovements;
